import axios from "axios";
import { takeLatest, put } from "redux-saga/effects";
import { API_BASE_URI } from "../ApiCall";
import { PurchaseBudgetRequisitionActionTypes } from "./PurchaseBudgetRequisition.type";

export function* fetchAllPurchaseBudgetRequisitions(action: any): any {
  try {
    const response = yield axios.get(`${API_BASE_URI}/purchase-budget-requisition`);
    yield put({
      type: PurchaseBudgetRequisitionActionTypes.FETCH_ALL_PURCHASE_BUDGET_REQUISITION_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    yield put({
      type: PurchaseBudgetRequisitionActionTypes.FETCH_ALL_PURCHASE_BUDGET_REQUISITION_FAILURE,
      payload: error,
    });
  }
}

export function* fetchOnePurchaseBudgetRequisition(action: any): any {
  try {
    const response = yield axios.get(
      `${API_BASE_URI}/purchase-budget-requisition/${action.payload}`
    );
    yield put({
      type: PurchaseBudgetRequisitionActionTypes.FETCH_ONE_PURCHASE_BUDGET_REQUISITION_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    yield put({
      type: PurchaseBudgetRequisitionActionTypes.FETCH_ONE_PURCHASE_BUDGET_REQUISITION_FAILURE,
      payload: error,
    });
  }
}

export function* watcherFetchAllPurchaseBudgetRequisitions() {
  yield takeLatest(
    PurchaseBudgetRequisitionActionTypes.FETCH_ALL_PURCHASE_BUDGET_REQUISITION,
    fetchAllPurchaseBudgetRequisitions
  );
}

export function* watcherFetchOnePurchaseBudgetRequisition() {
  yield takeLatest(
    PurchaseBudgetRequisitionActionTypes.FETCH_ONE_PURCHASE_BUDGET_REQUISITION,
    fetchOnePurchaseBudgetRequisition
  );
} 